import React from 'react';
import ReactDOMServer from "react-dom/server";

const allSet = <div className="new-quote-container centered">
  <div className="splash-icon">🎉</div>
  <div className="splash-header">
    <h1 className="no-word-break">You're all set!</h1>
    <div className="quote">Invite on the way. You've just made training more fun-and more consistent.</div>
  </div>
</div>;

const allSetElement = {
  name: 'training-circle',
  type: 'html',
  html: ReactDOMServer.renderToStaticMarkup(allSet),
}

export default allSetElement;
